import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { readCallbackParams } from "@/lib/socialpulseOidc";
import { useAuth } from "@/context/AuthContext";

export default function SocialPulseCallback() {
  const [error, setError] = useState("");
  const { loginWithToken } = useAuth();
  const navigate = useNavigate();
  const ran = useRef(false);

  useEffect(() => {
    if (ran.current) return;
    ran.current = true;
    const params = readCallbackParams();
    if (!params) {
      setError("Invalid or expired login response. Please try signing in again.");
      return;
    }
    const { returnTo, ...body } = params;
    api.post("/auth/socialpulse/callback", body)
      .then((r) => {
        loginWithToken(r.data.token, r.data.user);
        navigate(returnTo, { replace: true });
      })
      .catch((e) => setError(e.response?.data?.detail || "Sign-in failed. Please try again."));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="min-h-[60vh] flex flex-col items-center justify-center gap-4" data-testid="sso-callback-page">
      {!error ? (
        <>
          <span className="eq-bars" style={{ height: 36 }}><span /><span /><span /><span /><span /></span>
          <p className="text-sm font-bold text-slate-600">Signing you in with SocialPulse SSO...</p>
        </>
      ) : (
        <>
          <p className="text-sm font-bold text-rose-600" data-testid="sso-callback-error">{error}</p>
          <button onClick={() => navigate("/")} className="gradient-btn text-white font-bold px-6 py-2.5 rounded-full text-sm">Back to home</button>
        </>
      )}
    </div>
  );
}
